export var gradientBackground = '$gvkvn';
export var shadow = '$eesS4';
export var placeholderColor = '$_1J7p-';
export var iconTranslate = '_2v-uq';
export var childrenTransitionProperties = '_3dkgp';
export var translateUp = 'b4725';
export var fdicLogo = '_1LHCT';